import React from 'react';

import Authorize from './Authorize';
import UnAuthorize from './UnAuthorize';

const NexHub = props => {
  return <>{props.token !== null ? <Authorize {...props} /> : <UnAuthorize {...props} />}</>;
};
export default NexHub;
